import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { jwtDecode } from 'jwt-decode'; // para decodificar token

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private cookieService: CookieService, private router: Router) {}

  canActivate(): boolean {
    const token = this.cookieService.get('token');

    if (!token) {
      this.router.navigate(['/login']); 
      return false;
    }

    try {
      const decoded: any = jwtDecode(token);
      const exp = decoded.exp; 
      const now = Math.floor(Date.now() / 1000);

      if (exp < now) {
        this.router.navigate(['/login']);
        return false;
      }

      return true; 
    } catch (err) {
      this.router.navigate(['/login']);
      return false;
    }
  }
}